import React, { useState, createContext } from 'react';

export const FormContext = createContext();

export function FormProvider({ children }) {
  const [useOfTerms, setUseOfTerms] = useState(false);
  const [errors, setErrors] = useState([]);

  const contextValue = {
    useOfTerms,
    setUseOfTerms,
    errors,
    setErrors,
  };

  return (
    <FormContext.Provider value={contextValue}>
      {children}
    </FormContext.Provider>
  );
}
